import PriceWithCurrency from "@/components/Helpers/PriceWithCurrency";
import { useTradeInContent } from "@/hooks/useTradeInContent";

/**
 * `hasTradeIn` is `trade_in` off the search index — a cheap pre-check so we do
 * not call the API on products with no offer. It does not decide what renders.
 */
function RulesPDP({ offers, locale, sku, hasTradeIn }) {
  // The index flag can be stale, so the card follows `service_id` from the API.
  // PDP shows only the promo block, so the other three components are not asked for.
  const { bySku } = useTradeInContent(hasTradeIn && sku ? [sku] : [], "promo");
  const tradeIn = bySku[sku];
  const promo = tradeIn?.components?.promo;

  // An empty `cart_rule` array is still truthy — which is why the old
  // `{product?.cart_rule && …}` gate never gated anything. Normalised so a
  // missing field cannot throw in `.map` below.
  const rules = Array.isArray(offers) ? offers : [];

  if (rules.length > 0 || tradeIn)
    return (
      <div className="rules-pdp-component flex flex-col justify-start items-start my-[1rem]">
        <h4 className="text-[24px] font-[700] text-[#292929] ">
          {locale === "ar" ? "العروض" : "Offers"}
        </h4>
        <div className="lower flex gap-4 mt-[1rem] w-[100%] overflow-x-auto">
          {tradeIn && (
            <div className="rule-pdp-item flex-1 flex flex-col items-center justify-center border rounded-[8px] min-h-[150px] p-[1rem]">
              <div className="upper w-full max-w-[340px] mx-auto flex flex-col items-center">
                <div className="inline-flex items-center gap-2">
                  <h3 className="head text-[18px] font-bold text-black">
                    {promo?.title}
                  </h3>
                  <PriceWithCurrency
                    amount={tradeIn?.service?.fixed_discount}
                    iconClassName="size-3"
                    className="gap-1 text-[15px] font-bold text-black"
                  />
                </div>
                <p className="mt-4 text-center text-base text-black">
                  {promo?.message}
                </p>
              </div>
            </div>
          )}
          {rules.map((item, index) => {
            return <RulePDPItem item={item} key={index} locale={locale} />;
          })}
        </div>
      </div>
    );

  return null;
}

export function RulePDPItem({ item, locale }) {
  return (
    <div className="rule-pdp-item flex-1 flex flex-col items-center justify-center border rounded-[8px] min-h-[150px] p-[1rem]">
      <div className="upper">
        <h3 className="head text-center text-[18px]">
          {item?.labels?.[locale === "ar" ? "14" : "2"]}
        </h3>
        <p className="text-[#292929] text-[14px] mt-[.5rem]">
          {item?.description}
        </p>
      </div>

      <p className="end-date text-[14px] font-[600]">
        {locale === "en" ? "Until" : "حتى"} :
        <span className="change-color-danger ms-[8px] font-[700]">
          {item?.to_date}
        </span>
      </p>
    </div>
  );
}

export default RulesPDP;
